import styled, { css } from 'styled-components';
import { Image, Form } from 'react-bootstrap';
import { theme } from '../../theme/theme';
import { Link } from '../shared/simple/Link';
import { t } from 'i18next';

const { sixth, first } = theme;

// Define element styles for the component
export const StyledImage = styled(Image)`
  height: 100px;
  margin-right: 10px;
  margin-bottom: 10px;
  width: 100px;
  border: 1px solid #eee;
  border-radius: 10px;
  cursor: pointer;
  box-shadow: 1px 1px 1px #eee;

  &.compact-grid {
    width: 80px;
    height: 80px;
    margin: 0;
  }
`;

export const StyledImageGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(80px, 1fr));
  gap: 10px;
  align-items: center;
  justify-items: center;
`;

export const LinkText = styled(Link)`
  font-size: 18px;
  cursor: pointer;
`;

export const StyledCheck = styled(Form.Check)`
  border-radius: .5rem;
  outline: none;
  &:focus {
    border-color: ${sixth};
    box-shadow: none;
  }
`;

export const StyledSelect = styled(Form.Select)`
  border: 1px solid #ced4da;
  background: #fff;
  color: #212529;

  ${({$isNewDesign}) => $isNewDesign && css`
    background: rgba(255, 255, 255, 0.16);
    border: 1px solid rgba(255, 255, 255, 0.38);
    color: #fff;

    option {
      color: #212529;
    }

    &:hover {
      background: rgba(255, 255, 255, 0.28) !important; 
    }

    &:disabled {
      background-color: rgba(30, 20, 50, 0.4) !important;     
    }

    &:disabled:hover {
      background-color: rgba(30, 20, 50, 0.4) !important;     
    }

      

    &:disabled {
      opacity: 1 !important;
      background-color: rgba(30, 20, 50, 0.4);     
      
      &::placeholder {
        opacity: 1 !important;
      }
        
    }

  `}

  &:focus {
    border-color: ${first};
    box-shadow: none;
  }
`;

export const StyledLogo = styled(Image)`
  height: 100px;
  margin-top: 15%;
  width: auto;

  @media (max-width: 767px) {
    margin-top: 50px;
  }
`;

export const StyledContainerQR = styled.div`
  position:relative;
  display:flex;
  flex-direction: column;
  padding-inline: 0 !important;
  align-items: center;
  & > h1{
    font-family: 'Roboto', sans-serif;
    padding-block: .75rem;
    margin: 0;
  }

  & > section{
    margin-top:20px
  }
`

/* Markup for Info Alert asking for liveness detection */
export const livenessWarning = (
  <div className="alert alert-warning" role="alert">
    {t('livenessDetection.livenessWarning')}
  </div>
);